import React, { useEffect, useRef, useState, useContext } from "react";
import Panel from "./Panel";
import useAlpacaOHLC from "hooks/useAlpacaOHLC";

import { useSelector, useDispatch } from "react-redux";
import { map_coins, map_coin_to_name } from "store/constant";
import { map_balance_to_coin } from "store/constant";
// import useKrakenOHLC from "hooks/useKrakenOHLC";
import { IconButton } from "@material-ui/core";
import DailyHiLo from "../../components/DailyHiLo";
import colors from "assets/scss/_themes-vars.module.scss";
import ToolTipHelper from 'ui-component/ToolTipHelper';
import {tooltips} from 'constants/tooltips';
import { addExploreRecent } from "../../../../../store/actions";
import { menuDetailsContext } from '../../../../../contexts/MenuDetailsProvider';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';

// material-ui
import { withStyles, useTheme } from "@material-ui/styles";
import { Badge, Chip, Grid, Link, Box, Typography, Tab, Tabs } from "@material-ui/core";
import { keyframes } from "@mui/system";

// third party
import ApexCharts from "apexcharts";
import TakyonLightweightChart from "./Chart";
import LandingSwlNegative from "../../SwlPositiveNegative/LandingSwlNegative";
import LandingPastPredictionsTable from "../../SwlPositiveNegative/components/LandingPastPredictionsTable";

// project imports
import SubCard from "ui-component/cards/SubCard";

import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import CoinContext from "contexts/CoinContext";
import TradesCoin from "../../Trades/TradesCoin";
import OrdersCoin from "./OrdersCoin.js";

import {
    FETCH_MLFORECAST_REQUEST,
    FETCH_MLFORECAST_REQUEST_SECOND,
    FETCH_MLFORECAST_REQUEST_THIRD,
    FETCH_MLFORECAST_REQUEST_FIRST,
} from "store/actions";


import { 
    setKrakenInterval, 
} from "store/actions";

const pulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 1;
  }

  50% {
    transform: scale(1.5);
    opacity: 0.35;
  }

  100% {
    transform: scale(0.9);
    opacity: 1;
  }
`;

function get830CentralEpoch() {
    const now = new Date();

    // Today's date in Central Time
    const formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: "America/Chicago",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });

    const parts = formatter.formatToParts(now);

    const year = parts.find(p => p.type === "year").value;
    const month = parts.find(p => p.type === "month").value;
    const day = parts.find(p => p.type === "day").value;

    // Build local Central date/time
    const centralDate = `${year}-${month}-${day}T08:30:00`;

    // Convert correctly using timezone
    const epoch = new Date(
        new Date(centralDate).toLocaleString("en-US", {
            timeZone: "America/Chicago",
        })
    ).getTime();

    return epoch;
}

// ===========================|| DASHBOARD ANALYTICS - MARKET SHARE AREA CHART CARD ||=========================== //

const CustomizedBadge = withStyles((theme) => ({
  badge: {
    right: -5,
    top: 0,
    border: `0px solid ${theme.palette.background.paper}`,
    padding: "0 0px",
  },
}))(Badge);

const CandleChartCard = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;
  const whiteTakyon =
    theme.palette.mode === "dark"
      ? colors.whiteLightTakyon
      : colors.whiteDarkTakyon;
  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;

  const [lcoin, setLcoin, menuDetails, setMenuDetails] = useContext(menuDetailsContext);

  const ohlcInterval = useSelector((state) => state.chart.ohlcInterval);
  const setInterval = (interval) => dispatch(setKrakenInterval(interval));

  // const portfolio = useSelector((state) => {
  //   const ltp =
  //     (state.takyon.mapTrendingBuy.get(coin) &&
  //       state.takyon.mapTrendingBuy.get(coin).trade_price) ||
  //     0.0;

  //   if (state.takyon.portfolio) {
  //     let position = state.takyon.portfolio.mapPosition.get(coin);
  //     if (position !== undefined) {
  //       return [
  //         position.balance.toFixed(2),
  //         (position.balance * ltp).toFixed(2),
  //         position.real,
  //         position.unreal,
  //         position.avg,
  //       ];
  //     } else {
  //       return [0, 0, 0, 0, 0];
  //     }
  //   } else {
  //     return [0, 0, 0, 0, 0];
  //   }
  // });

  // const customization = useSelector((state) => state.customization);
  // const { navType } = customization;

  const coin_style = map_coins.get(lcoin);
  // const coin_name = map_coin_to_name.get(lcoin) ? map_coin_to_name.get(lcoin) : lcoin;
  const coin_name = useSelector((state) => {
    const row = state.coins.kraken_asset_pairs && state.coins.kraken_asset_pairs.get(lcoin) && state.coins.kraken_asset_pairs.get(lcoin) || undefined;
    if ( row === undefined)
    {
        return lcoin;
    }
    const coin_name = row.marketcap ?  row.marketcap.Name : (row.base_currency ? row.base_currency : (row.base ? row.base : row.wsname));
    return coin_name;
  });

  const [tabsValue, setTabsValue] = React.useState(0);
  const [aCount, setACount] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabsValue(newValue);
  };

  const handleCoinSelect = (event, newValue) => {
    // TMD console.log('HANDLE_COIN_SELECT ' + newValue);
    dispatch(addExploreRecent(newValue));
    setLcoin(newValue);
    // TMD console.log( 'SET_CONTEXT ' + lcoin);
  };

  const intervals = [
    { interval: "5", title: "5m" },
    { interval: "15", title: "15m" },
    { interval: "30", title: "30m" },
  ];

  // const coin_list = ["SPY", "SPCX", "NVTS", "FCEL", "CIFR", "CRCL", "COIN", "NBIS"];
  const coin_list = ["SPY", "FCEL", "TSEM", "IONQ", "POET", "CRWV", "SPCX", "NBIS"];

  const ltp = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(lcoin)               &&
                 state.coins.kraken_asset_pairs.get(lcoin).ltp
                 )
                 || undefined);
  });

  const day_close = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(lcoin)               &&
                 state.coins.kraken_asset_pairs.get(lcoin).day_close
                 )
                 || undefined);
  });

  const daily = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(lcoin)               &&
                 state.coins.kraken_asset_pairs.get(lcoin).daily
                 )
                 || undefined);
  });

  const daily_hi = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(lcoin)               &&
                 state.coins.kraken_asset_pairs.get(lcoin).daily_hi
                 )
                 || 0.0);
  });
  const daily_lo = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(lcoin)               &&
                 state.coins.kraken_asset_pairs.get(lcoin).daily_lo
                 )
                 || 0.0);
  });
  const daily_percent = useSelector((state) => {
     return (
                (
                 state.coins.kraken_asset_pairs.get(lcoin)               &&
                 state.coins.kraken_asset_pairs.get(lcoin).hilo_percent
                 )
                 || 0.0);
  });

    ////////////////////////////////////////////
    // Check if mlpData exists. If not, issue
    ////////////////////////////////////////////

  let mapSecond =  useSelector((state) => state.chart.mapSecondMLForecast);

    useEffect(() => {
        const now = Date.now() / 1000;
        const diff = now - 1783882760;
        // TMD console.log('LANDING_CANDLE_CHART ------ PREDICT  --- START REQUEST ' + lcoin + ', now: ' + now + ', start: ' + 1783882760 + ', diff: ' + diff);

        // TMD console.log(mapSecond);
        const mlpData = mapSecond.get(lcoin + "-15");
        // TMD console.log(mlpData);

        if (mlpData === undefined)
        {
            {
                const postdata = { "query": {"height": 25, "type": 2, "time": get830CentralEpoch(), "symbol": lcoin + "-15"}};
                // TMD console.log(JSON.stringify(postdata));
                dispatch( {type: FETCH_MLFORECAST_REQUEST_SECOND, payload: postdata});
            }
            {
                const postdata = { "query": {"height": 10, "type": 2, "time": get830CentralEpoch(), "symbol": lcoin + "-30"}};
                // TMD console.log(JSON.stringify(postdata));
                dispatch( {type: FETCH_MLFORECAST_REQUEST_THIRD, payload: postdata});
            }
            {
                const postdata = { "query": {"height": 35, "type": 2, "time": get830CentralEpoch(), "symbol": lcoin + "-5"}};
                // TMD console.log(JSON.stringify(postdata));
                dispatch( {type: FETCH_MLFORECAST_REQUEST, payload: postdata});
            }
            // TMD console.log('LANDING_CANDLE_CHART ------ PREDICT  --- END---REQUEST ' + lcoin + ', now: ' + now + ', start: ' + 1783882760 + ', diff: ' + diff);
        }
    }, [lcoin]);

  const reloadPrediction = () => {
    console.log( 'RELOAD PREDICTION for ' + lcoin);
            {
                const postdata = { "query": {"height": 25, "type": 2, "time": get830CentralEpoch(), "symbol": lcoin + "-15"}};
                console.log(JSON.stringify(postdata));
                dispatch( {type: FETCH_MLFORECAST_REQUEST_SECOND, payload: postdata});
            }
            {
                const postdata = { "query": {"height": 10, "type": 2, "time": get830CentralEpoch(), "symbol": lcoin + "-30"}};
                console.log(JSON.stringify(postdata));
                dispatch( {type: FETCH_MLFORECAST_REQUEST_THIRD, payload: postdata});
            }
            {
                const postdata = { "query": {"height": 35, "type": 2, "time": get830CentralEpoch(), "symbol": lcoin + "-5"}};
                console.log(JSON.stringify(postdata));
                dispatch( {type: FETCH_MLFORECAST_REQUEST, payload: postdata});
            }
  };

  // Let's get the count here.
  const alertCountPositive = useSelector((state) => {
    if (
      state.coins.alerts === undefined ||
      state.coins.alerts.alertsSP === undefined
    )
      return 0;
    else return state.coins.alerts.alertsSP.size;
  });

  const alertCountNegative = useSelector((state) => {
    if (
      state.coins.alerts === undefined ||
      state.coins.alerts.alertsSN === undefined
    )
      return 0;
    else return state.coins.alerts.alertsSN.size;
  });

  let alertCount = (alertCountPositive + alertCountNegative) === 0 ? 12 : (alertCountPositive + alertCountNegative);;
  // NOT YET alertCount = (alertCount === 0) ? 12 : alertCount;

  // TMD console.log('ALERTS COUNT: ' + alertCountPositive + ', ' + alertCountNegative + ', total: ' + alertCount);

  useEffect(() => {
    if ( alertCount !== aCount)
    {
        setACount(alertCount);
    }
  }, [aCount]);

  return (
         <SubCard sx={{ width: 850, background: '#15140f', boxShadow: '0 10px 20px rgb(40 51 75 / 80%)' }}>
            {(tabsValue !== 2) && (
                <Box
                    sx={{
                        display:"flex",
                        justifyContent:"flex-end",
                        alignItems:"center",
                        gap:1
                    }}
                >
                    <Box
                        sx={{
                            width:8,
                            height:8,
                            borderRadius:"50%",
                            bgcolor:"#2ecc71",
                            animation:`${pulse} 1.5s infinite`,
                        }}
                    />

                    <Typography
                        sx={{
                            color:"lightgreen",
                            fontWeight:600,
                            fontSize:20
                        }}
                    >
                        Live
                    </Typography>
                </Box>
             )}
             <Tabs
                value = {tabsValue}
                onChange={handleChangeTab}
                aria-label="ant example"
             >
                <Tab
                    label={
<Chip
    label={<font style={{ "font-size": "0.8rem" }} >CHARTS</font> }
    size="small"
    sx={{
        bgcolor: "#1ED760",
        color: "#000",
        fontWeight: 800,
        letterSpacing: 1,

        px: 1,
        height: 28,

        borderRadius: "8px",

        "&:hover": {
            bgcolor: "#25e96b",
            boxShadow: `
                0 0 12px rgba(30,215,96,.85),
                0 0 28px rgba(30,215,96,.45)
            `,
        },
    }}
/>
                         }
                />
                <Tab
                    label={
                                    <CustomizedBadge badgeContent={alertCount} color="error">
<Chip
    label={<font style={{ "font-size": "0.8rem" }} >BREAKOUTS</font> }
    size="small"
    sx={{
        bgcolor: "#1ED760",
        color: "#000",
        fontWeight: 800,
        letterSpacing: 1,

        px: 1,
        height: 28,

        borderRadius: "8px",

        "&:hover": {
            bgcolor: "#25e96b",
            boxShadow: `
                0 0 12px rgba(30,215,96,.85),
                0 0 28px rgba(30,215,96,.45)
            `,
        },
    }}
/>
                                    </CustomizedBadge>
                         }
                />
                <Tab
                    label={
<Chip
    label={<font style={{ "font-size": "0.8rem" }} >Historical</font> }
    size="small"
    sx={{
        bgcolor: "#1ED760",
        color: "#000",
        fontWeight: 800,
        letterSpacing: 1,

        px: 1,
        height: 28,

        borderRadius: "8px",

        "&:hover": {
            bgcolor: "#25e96b",
            boxShadow: `
                0 0 12px rgba(30,215,96,.85),
                0 0 28px rgba(30,215,96,.45)
            `,
        },
    }}
/>
                         }
                />
             </Tabs>

                {tabsValue === 0 && (
                <>
              <Grid container spacing={2} padding={2} alignItems="left">
                    {coin_list.map((citem) => {
                        const cstyle = map_coins.get(citem);
                        return(
                        <>
                <Grid item xs={1.5}  align="left" justifyContent="left" alignItems="left" >
                      <Link
                        key={'subscribe'}
                        aria-current={"page"}
                        onClick={(event) => handleCoinSelect(event, citem)}
                        sx={{
                            "&:hover": {
                                bgcolor: "#444",
                                boxShadow: `
                                    0 0 8px rgba(0,215,0,.85),
                                    0 0 8px rgba(0,215,0,.45)
                                `,
                            },
                        }}
                      >
                            {/*
                            <Button
                                variant="outlined"
                                sx={{
                                    minWidth: "auto",
                                    py: 1.5,
                                    borderRadius: '8px',
                                    border: 'black',
                                    borderColor: 'black',
                                    background: ((lcoin === citem) ? 'orange' : 'lightgray'),
                                    color: ((lcoin === citem) ? 'white' : 'black'),
                                    borderColor: 'orange',
                                    fontWeigth: 'bold',
                                    "&:hover": {
                                        bgcolor: "#25e96b",
                                        boxShadow: `
                                            0 0 12px rgba(30,215,96,.85),
                                            0 0 28px rgba(30,215,96,.45)
                                        `,
                                    },
                                }}
                            >
                                <Typography sx={{ fontSize: '1.0rem', color: ((lcoin === citem) ? 'white' : 'black'), fontWeight: 'bold' }} >
                                {citem}
                                </Typography>
                            </Button>
                            */}
                        <a class={cstyle}> {citem} </a>
                      </Link>
                </Grid>
                    </>
                        );
                    })}
                <Grid item xs={12} align="left" justifyContent="left" alignItems="left" />
                <Grid item xs={1} align="left" justifyContent="left" alignItems="left">
                    <IconButton
                        onClick={reloadPrediction}
                        sx={{
                            marginTop: '-10px',
                            bgcolor: "#1A2436",
                            color: "#00E060",
                            border: "1px solid #2A3B52",
                            "&:hover": {
                                bgcolor: "#223047",
                            },
                        }}
                    >
                        <AutorenewRoundedIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={3} align="left" justifyContent="left" alignItems="left">
                  <font style={{ "font-weight": 'bold', "font-size": "3.0rem", "color": "cornsilk",  }} >
                      {lcoin}
                    </font>
                </Grid>
                <Grid item xs={4} align="center" justifyContent="right" alignItems="right">
                {intervals.map((intervalItem) => (
                  <IconButton
                    key={intervalItem.interval}
                    sx={{
                      color:
                                (intervalItem.interval === ohlcInterval && ohlcInterval === "5")
                                  ? 'yellow'
                                  : ( (intervalItem.interval === ohlcInterval && ohlcInterval === "15")
                                        ? '#FFA500'
                                        : ((intervalItem.interval === ohlcInterval && ohlcInterval === "30")
                                            ? 'red'
                                            : 'darkgray'
                                          )
                                    ),
                    }}
                    size="small"
                    onClick={() => setInterval(intervalItem.interval)}
                  >
                    {intervalItem.title}
                  </IconButton>
                ))}
                </Grid>
                <Grid item xs={4} align="right" justifyContent="right" alignItems="right">
                  {(ltp === undefined) && (<Panel ltp={day_close} daily_hi={daily_hi} daily_lo={daily_lo} daily_percent={daily_percent} />)}
                  {(ltp !== undefined) && (<Panel ltp={ltp} daily_hi={daily_hi} daily_lo={daily_lo} daily_percent={daily_percent} />)}
                </Grid>
              </Grid>

              <TakyonLightweightChart chart_index={0} current_coin={lcoin}/>

            </>
        )}
         {tabsValue === 1 && (
            <LandingSwlNegative />
         )}
         {tabsValue === 2 && (
            <LandingPastPredictionsTable />
         )}
     </SubCard>
  );
};
export default CandleChartCard;
